import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';

@Injectable()
export class UserMessageService {
	userMessageSource: Subject<any>;
	userMessageObserver;
	userMessages: any[] = []; // this is a history of all user messages

	constructor () {
		this.userMessageSource = new Subject<{}>();
		this.userMessageObserver = this.userMessageSource.asObservable();
	}

	log ( message ) {
		this.userMessageSource.next( message );
		this.userMessages.push( message );
	}
}